import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginPageComponent } from './login-page/login-page.component';
import { ResetPasswordHashComponent } from './reset-password-hash/reset-password-hash.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { WholesaleLoginComponent } from './wholesale-login/wholesale-login.component';
import { RedirectGuard } from './redirect.guard';
import { NonWholesaleGuardService } from './auth/non-wholesale-guard.service';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'download',
    pathMatch: 'full',
  },
  {
    path: 'profile',
    loadChildren: () => import('./profile/profile.module').then(m => m.ProfileModule)
  },
  {
    path: 'order/:url_alias',
    redirectTo: 'profile/order/:url_alias',
  },
  {
    path: 'order/:url_alias/downloads',
    redirectTo: 'profile/order/:url_alias/downloads',
  },

  {
    path: 'order-shopify/:url_alias',                     // #1358
    redirectTo: 'profile/order-shopify/:url_alias',
  },
  {
    path: 'order-shopify/:url_alias/downloads',           // #1358
    redirectTo: 'profile/order-shopify/:url_alias/downloads',
  },

  {
    path: 'iheartvinyl',           // #1358
    redirectTo: 'download',
  },
  {
    path: 'download',
    canActivate: [NonWholesaleGuardService],
		loadChildren: () => import('./iheartvinyl/iheartvinyl.module').then(m => m.IheartvinylModule)
  },
  {
    path: 'cms',
		loadChildren: () => import('./cms/cms.module').then(m => m.CmsModule)
  },
  {
    path: '**',
    redirectTo: 'download',
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    initialNavigation: 'enabled',
    scrollPositionRestoration: 'top',
    relativeLinkResolution: 'legacy'
})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
